// extracted by mini-css-extract-plugin
export default {"overallItems":"NotificationBar_overallItems__x8rPu","Header":"NotificationBar_Header__AArYN","AlertContent":"NotificationBar_AlertContent__L5KHm"};